import clipboard from '@consumer/assets/icons/new/clipboard.svg?svgicon'
import creditCard from '@consumer/assets/icons/new/credit-card.svg?svgicon'
import envelopeOpen from '@consumer/assets/icons/new/envelope-open.svg?svgicon'
import handPointing from '@consumer/assets/icons/new/hand-pointing.svg?svgicon'
import receipt from '@consumer/assets/icons/new/receipt.svg?svgicon'
import storefront2 from '@consumer/assets/icons/new/storefront-2.svg?svgicon'
import userCircle from '@consumer/assets/icons/new/user-circle.svg?svgicon'

// Keyed by the `icon` values Consumer::SupportController emits per category.
export const SUPPORT_CATEGORY_ICONS: Record<string, string> = {
  clipboard,
  'credit-card': creditCard,
  'envelope-open': envelopeOpen,
  'hand-pointing': handPointing,
  receipt,
  'storefront-2': storefront2,
  'user-circle': userCircle,
}
